<template>
  <hm-content title>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="我的模板" name="my">
        <div class="flex mb20">
          <div>
            <el-button type="primary" size="small" @click="activeName = 'lib'"
              >添加</el-button
            >
          </div>
        </div>
        <div>
          <el-table
            stripe
            border
            :data="myTempMsgList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (myCurrentPage - 1) * myPageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="title"
              label="标题"
            ></el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="name"
              label="归属小程序"
            ></el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="example"
              show-overflow-tooltip
              label="示例"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="模板ID"
            >
              <template slot-scope="scope">
                <div class="flex item-center flex-center">
                  <div class="id-overflow" :title="scope.row.priTmplId">
                    {{ scope.row.priTmplId }}
                  </div>
                  <input
                    type="text"
                    class="url"
                    :value="scope.row.priTmplId"
                    ref="activityListUrl"
                  />
                  <el-button
                    type="text"
                    size="small"
                    @click="copyUrl(scope.row)"
                    >复制</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="操作"
            >
              <template slot-scope="scope">
                <!-- <el-button
                  class="primary"
                  size="small"
                  type="text"
                  @click="toDetails(scope.row)"
                  >详情</el-button
                >-->
                <el-button
                  class="primary"
                  size="small"
                  type="text"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="hm-pagination mb20">
          <el-pagination
            background
            :page-sizes="[10, 20, 30]"
            :total="myTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div> -->
      </el-tab-pane>
      <el-tab-pane label="模板库" name="lib">
        <div>
          <span>消息类型：</span>
          <el-select
            size="small"
            placeholder="选择模板类型"
            v-model="tempType"
            style="width: 200px"
            @change="changeTempType"
            filterable
          >
            <el-option
              v-for="(item, i) in tempTypeList"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="table mb20 mt20">
          <el-table
            stripe
            border
            :data="groupList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="tid"
              label="ID"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="title"
              show-overflow-tooltip
              label="标题"
            ></el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="stockNum"
              label="常见关键词"
              show-overflow-tooltip
            ></el-table-column>-->
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  class="primary"
                  size="small"
                  type="text"
                  @click="toDetails(scope.row, 'edit')"
                  >选用</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            :page-sizes="[10, 20, 30]"
            background
            :total="groupListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tempType: "",
      myCurrentPage: 1,
      myPageSize: 10,
      currentPage: 1,
      pageSize: 10,
      activeName: "my",
      myTempMsgList: [],
      data: [],
      groupList: [],
      groupListTotal: 0,
      myTotal: 0,
      tempTypeList: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryMyTempMsgList();
    this.querySubscriptionCate();
  },
  mounted() {},
  methods: {
    changeTempType() {
      this.currentPage = 1;
      this.queryList();
    },
    async querySubscriptionCate() {
      const { result } = await this.$store.dispatch("wxTemplateGetCategory");
      const { data } = result;
      this.tempTypeList = data;
      this.tempType = this.tempTypeList[0].id;
      this.queryList();
    },
    async queryMyTempMsgList() {
      const { result } = await this.$store.dispatch("getMyTemplateList", {
        count: this.myPageSize,
        offset: (this.myCurrentPage - 1) * this.myPageSize
      });
      const { data } = result;
      this.myTempMsgList = [];
      // data.map(v => {
      //   // v.data.forEach(o => {
      //   o.name = v.name;
      //   o.miniProgramType = v.miniProgramType;
      //   // });

      // });
      this.myTempMsgList = this.myTempMsgList.concat(data);
    },
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy");
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },
    async queryList() {
      const { result } = await this.$store.dispatch("getPubTemplateTitleList", {
        ids: this.tempType,
        start: (this.currentPage - 1) * this.pageSize,
        limit: this.pageSize
      });
      const { data, count } = result;
      this.groupList = data;
      this.groupListTotal = count;
    },
    toDetails(row, type) {
      this.$router.push({
        name: "AddOfficialTempMsg",
        query: {
          tid: row.tid,
          title: row.title
        }
      });
      //   if (type) {
      //     this.$router.push({
      //       name: "AddTempMsg",
      //       query: {
      //         tid: row.tid,
      //         title: row.title
      //       }
      //     });
      //   } else {
      //     this.$router.push({
      //       name: "TempMsgDetails",
      //       query: {
      //         id: row.id
      //       }
      //     });
      //   }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleClick() {},
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("removeTempMsg", {
          priTmplId: row.priTmplId,
          miniProgramType: row.miniProgramType
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryMyTempMsgList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.id-overflow {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  white-space: nowrap;
}

.url {
  width: 1px;
  opacity: 0;
  border: none;
}
</style>
